import React from "react";
import { HeroSection, Footer } from "../../components";

const Home = () => {
  return (
    <div className="flex flex-col min-h-screen font-sans bg-green-900 text-white">
      {/* Main Hero */}
      <main className="flex-grow flex items-center justify-center">
        <HeroSection />
      </main>

      {/* Footer always visible */}
      {/* <Footer /> */}
    </div>
  );
};

export default Home;